import { Link } from 'react-router-dom';
import { Users, Music, Calendar, Shield } from 'lucide-react';
import { useAdminStats } from '../../hooks/useAdmin';

export default function AdminDashboardPage() {
  const { stats, loading } = useAdminStats();

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <div className="flex items-center gap-3 mb-8">
        <Shield className="w-7 h-7 text-red-400" />
        <h1 className="text-3xl font-bold">Admin Panel</h1>
      </div>

      {loading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-400"></div>
        </div>
      ) : (
        <>
          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-5">
              <p className="text-3xl font-bold">{stats.totalUsers}</p>
              <p className="text-gray-400 text-sm mt-1">Total Users</p>
            </div>
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-5">
              <p className="text-3xl font-bold">{stats.totalBands}</p>
              <p className="text-gray-400 text-sm mt-1">Total Bands</p>
            </div>
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-5">
              <p className="text-3xl font-bold">{stats.totalEvents}</p>
              <p className="text-gray-400 text-sm mt-1">Total Events</p>
            </div>
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-5">
              <p className="text-3xl font-bold">{stats.totalPublicEvents}</p>
              <p className="text-gray-400 text-sm mt-1">Public Events</p>
            </div>
          </div>

          {/* Quick links */}
          <h2 className="text-xl font-semibold mb-4">Manage</h2>
          <div className="grid md:grid-cols-3 gap-4">
            <Link
              to="/admin/users"
              className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-indigo-500/50 transition group"
            >
              <Users className="w-8 h-8 text-indigo-400 mb-3 group-hover:scale-110 transition-transform" />
              <h3 className="font-semibold text-lg mb-1">Users</h3>
              <p className="text-gray-400 text-sm">
                View all users, edit profiles, send password resets, manage admin access.
              </p>
            </Link>
            <Link
              to="/admin/bands"
              className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-indigo-500/50 transition group"
            >
              <Music className="w-8 h-8 text-indigo-400 mb-3 group-hover:scale-110 transition-transform" />
              <h3 className="font-semibold text-lg mb-1">Bands</h3>
              <p className="text-gray-400 text-sm">
                View all bands, edit details, toggle visibility, delete bands.
              </p>
            </Link>
            <Link
              to="/admin/events"
              className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-indigo-500/50 transition group"
            >
              <Calendar className="w-8 h-8 text-indigo-400 mb-3 group-hover:scale-110 transition-transform" />
              <h3 className="font-semibold text-lg mb-1">Events</h3>
              <p className="text-gray-400 text-sm">
                View all events across all bands, edit or delete events.
              </p>
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
